import { Component, inject } from '@angular/core';
import { Dialog } from '../dialog';
import {
  CONFIGURATION_SETTING_KEYS,
  EDirectSaleAlternatePassengerData,
  EEntityType,
  ERelationType,
  ITicket,
  NamedTariffProductDefinition,
} from '@web/dtos';
import { ButtonComponent } from '../../feedback/button/button.component';
import { DialogComponent } from '../dialog/dialog.component';
import { FormArray, FormGroup } from '@angular/forms';
import { ITicketOwnerDataForm } from '../../../pages/shop/direct-ticket-configuration-page/direct-ticket-owner-data-page/direct-ticket-owner-data-page.component';
import {
  ITicketOwnerMandatoryFields,
  ShoppingCartFormService,
} from '../../../services/shopping-cart/shopping-cart-form.service';
import { DirectTicketOwnerDataFormComponent } from '../../data-input/direct-ticket-owner-data-form/direct-ticket-owner-data-form.component';
import { ShoppingCartService } from '../../../services/shopping-cart/shopping-cart.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { ConfigurationStore } from '../../../services/api/configuration/configuration-store.service';

@Component({
  selector: 'aw-direct-ticket-edit-owner-shopping-cart-dialog',
  imports: [
    ButtonComponent,
    DialogComponent,
    DirectTicketOwnerDataFormComponent,
    FilterTextsPipe,
    LanguagePipe,
  ],
  templateUrl: './direct-ticket-edit-owner-shopping-cart-dialog.component.html',
})
export class DirectTicketEditOwnerShoppingCartDialogComponent extends Dialog<{
  index: number;
  name: string;
  ticket: ITicket;
  productDefinition: NamedTariffProductDefinition;
}> {
  private readonly shoppingCartFormService: ShoppingCartFormService = inject(
    ShoppingCartFormService
  );
  private readonly shoppingCartService: ShoppingCartService =
    inject(ShoppingCartService);
  private readonly configurationStore: ConfigurationStore =
    inject(ConfigurationStore);
  protected readonly textStore: WebTextStore = inject(WebTextStore);

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;

  protected ticketOwnerForms: FormArray<FormGroup<ITicketOwnerDataForm>> =
    this.shoppingCartFormService.createTicketOwnerForm(
      this.getTicketOwnerMandatoryFields(),
      this.shoppingCartService.ticketOwnerDataForms.controls[this.data.index]
        .length,
      undefined,
      this.shoppingCartService.productForms.controls[this.data.index].controls
        .amountOfPeople.value
    );

  constructor() {
    super();
    this.ticketOwnerForms.setValue(
      this.shoppingCartService.ticketOwnerDataForms.controls[
        this.data.index
      ].getRawValue()
    );
  }

  protected saveChanges(): void {
    this.shoppingCartService.ticketOwnerDataForms.controls[
      this.data.index
    ].setValue(this.ticketOwnerForms.getRawValue() as any);
    this.dialogRef.close();
  }

  private getTicketOwnerMandatoryFields(): ITicketOwnerMandatoryFields {
    return {
      isAlternatePassengerDataSalutationRequired:
        this.configurationStore.hasMultiSelectConfigurationValue(
          CONFIGURATION_SETTING_KEYS.DirectSaleAlternatePassengerData,
          EDirectSaleAlternatePassengerData.Salutation
        ),
      isAlternatePassengerDataDateOfBirthRequired:
        this.configurationStore.hasMultiSelectConfigurationValue(
          CONFIGURATION_SETTING_KEYS.DirectSaleAlternatePassengerData,
          EDirectSaleAlternatePassengerData.DateOfBirth
        ),
    };
  }
}
